module.exports = __webpack_public_path__ + "static/img/nav1.5635c3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav1.jpg
// module id = ELCk
// module chunks = 62